﻿import { addCommands, clearCommands } from './commands';
import { commandFactory } from './factory';

const mainWindow = window.aras ? window.aras.getMainWindow() : window;
let { cuiCommands } = mainWindow;
if (!cuiCommands) {
	cuiCommands = {
		addCommands,
		clearCommands,
		commandFactory
	};
	mainWindow.cuiCommands = cuiCommands;
}

export default cuiCommands;
